import * as React from 'react'

import { type SelectOption } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import type ArgumentForm from 'modules/reports/components/Editor/Field/Options/Types/Filtering/ArgumentForm'
import Condition from 'modules/reports/store/models/Condition'
import nationalitiesCollection from 'modules/reports/store/models/Nationality'

interface Props {
  forms: ArgumentForm[]
}

const NationalitySelector = ({ forms }: Props) => {
  const form = forms[0]
  const [loading, setLoading] = React.useState(true)

  useEffect(() => {
    const load = async () => {
      await nationalitiesCollection.fetch()
      setLoading(false)
    }

    load()
  }, [])

  if (loading) return null
  if (!form) return null

  const extraCountries: SelectOption[] = [
    {
      value: Condition.NOT_DEFINED,
      label: i18n.t(`custom_reports.especial_filters.not_defined`),
    },
  ]

  const list = nationalitiesCollection.toArray().map((e) => e.toJS())

  return (
    <FormRow>
      <Select
        label={i18n.t('custom_reports.especial_filters.employee_nationality.label')}
        none={i18n.t('custom_reports.especial_filters.employee_nationality.none')}
        options={[...extraCountries, ...list]}
        showOriginalLabelText
        field={form.get('value')}
      />
    </FormRow>
  )
}

export default observer(NationalitySelector)
